import type { ThreatsListRepository } from './mappers';
import type { GatorProtectThreatsListResponseApi } from './api.types';

export const MOCK_THREATS_LIST_RESPONSE_API: GatorProtectThreatsListResponseApi = {
  success: true,
  http_status_code: 200,
  internal_code: 0,
  data: {
    files: [
      {
        name: 'options.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2023/05/options.php.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.084+00:00',
        remediated_at: '2026-04-08T19:45:13.931+00:00',
      },
      {
        name: '20d42c42.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2023/02/20d42c42.php.quarentine',
        category: 'malicious',
        status: 'remediated',
        detected_at: '2026-04-08T19:45:18.081+00:00',
        remediated_at: '2026-04-08T19:45:13.924+00:00',
      },
      {
        name: 'lKzfrrd.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2023/11/lKzfrrd.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.077+00:00',
        remediated_at: '2026-04-08T19:45:13.923+00:00',
      },
      {
        name: 'vjhfayeg.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2023/11/vjhfayeg.php.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.075+00:00',
        remediated_at: '2026-04-08T19:45:13.922+00:00',
      },
      {
        name: 'kvfecdyj.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2024/10/kvfecdyj.php.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.072+00:00',
        remediated_at: '2026-04-08T19:45:13.900+00:00',
      },
      {
        name: 'wp-login.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2024/11/wp-login.php.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.070+00:00',
        remediated_at: '2026-04-08T19:45:13.899+00:00',
      },
      {
        name: 'pkhobyfz.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2024/08/pkhobyfz.php.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.068+00:00',
        remediated_at: '2026-04-08T19:45:13.898+00:00',
      },
      {
        name: 'JItLj.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-content/uploads/2024/08/JItLj.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.065+00:00',
        remediated_at: '2026-04-08T19:45:13.896+00:00',
      },
      {
        name: '.7949d7c5.css.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/wp-includes/blocks/latest-posts/.7949d7c5.css.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.063+00:00',
        remediated_at: '2026-04-08T19:45:11.311+00:00',
      },
      {
        name: '5gb20r2p.php.quarentine',
        path: '/home1/oricom96/expertanuncios.com.br/5gb20r2p.php.quarentine',
        category: 'malicious',
        status: 'quarantined',
        detected_at: '2026-04-08T19:45:18.060+00:00',
        remediated_at: '2026-04-08T19:45:10.558+00:00',
      },
    ],
    page: {
      current_page: 1,
      per_page: 10,
      total: 1469,
      last_page: 147,
    },
  },
  notifications: [],
};

export const mockThreatsListRepository: ThreatsListRepository = {
  fetchPage: () => Promise.resolve(MOCK_THREATS_LIST_RESPONSE_API),
};
